import React from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import Select from "react-select";
import Pagination from "react-paginating";
import LoadingSkeleton from "../loading-skeleton/loading-skeleton.component";
import { Row, Col, Container } from "react-bootstrap";
import NextActionList from "../../interactions/next-action.js";

// Constants
import ENDPOINTS from "../../utils/endpoints";

import "./tasks.styles.scss";

class Tasks extends React.Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);

    if (
      this.props.location.search == "" &&
      JSON.parse(localStorage.getItem("task"))?.userData == null
    ) {
      window.location.href = process.env.REACT_APP_WEB_LOGIN_URL;
    }

    this.state = {
      serviceData: [],
      userData: this.props.location.search
        ? this.props.location.search
        : JSON.parse(localStorage.getItem("task")).userData,
      redirect: false,
      showFilters: false,
      filtersTitle: "Ver Filtros",
      idInputValue: "",
      idB2bInputValue: "",
      filteredArray: [],
      selectedStageOption: "",
      stageOptions: [],
      selectedDateOption: "",
      dateOptions: [],
      currentPage: 1,
      token: false,
      helperId: false,
      nexActionsList: null,
    };

    localStorage.setItem("task", JSON.stringify(this.state));

    this.handleFilters = this.handleFilters.bind(this);
  }

  controller = new AbortController();

  handlePageChange = (page, e) => {
    this.setState({
      currentPage: page,
    });
  };

  decryptUserData() {
    const decryptedStr = this.handleHash(this.state.userData);
    const passwordArr = decryptedStr.split("password=");
    const pass = passwordArr[1];
    const usernameArr = passwordArr[0].split("username=");
    const user = usernameArr[1].slice(0, -1);

    return [user, pass];
  }

  handleHash(hash) {
    try {
      return atob(hash.substr(1));
    } catch (e) {
      console.log("Error en Handle hash");
      this.setState({ redirect: true });
    }
  }

  loginCheckAPI(urlLoginCheckAPI, userObject) {
    axios.post(urlLoginCheckAPI, userObject).then(
      async (result) => {
        this.setState({ token: result.data.token });

        const preparedConfig = {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
            accept: "application/json",
          },
        };

        this.setState({ nextActionsList: new NextActionList(preparedConfig) });

        await this.state.nextActionsList.initNextActions();

        this.getHelperId(ENDPOINTS.userMe, preparedConfig);
      },
      (error) => {
        window.location.href = process.env.REACT_APP_WEB_LOGIN_URL;
      }
    );
  }

  getHelperId(urlGetHelperId, preparedConfig) {
    axios.get(urlGetHelperId, preparedConfig).then(
      (result) => {
        this.setState({
          helperId: result.data.UsersCode,
        });

        if (!result.data.helper_active) {
          this.setState({ redirect: true });
        }

        localStorage.setItem("taskList", JSON.stringify(this.state));

        const urlGetHelperTasks = ENDPOINTS.services.list;

        this.getHelperTasks(urlGetHelperTasks, preparedConfig);
      },
      (error) => {
        console.log("Error en get helper api");
        this.setState({ redirect: true });
      }
    );
  }

  componentDidMount() {
    let secureArray = this.decryptUserData();
    const userObject = {
      username: secureArray[0],
      password: secureArray[1],
    };
    const urlLoginCheckAPI = ENDPOINTS.urlLoginCheckAPI;

    this.loginCheckAPI(urlLoginCheckAPI, userObject, secureArray);
  }

  componentWillUnmount() {
    this.signal.cancel("API is being canceled");
    this.controller.abort();
  }

  getHelperTasks(urlGetHelperTasks, preparedConfig) {
    axios.get(urlGetHelperTasks, preparedConfig).then(
      (result) => {
        this.setState({
          serviceData: result.data,
          filteredArray: this.paginatorNormalizer(result.data),
          stageOptions: this.stageOptionsNormalizer(result.data),
          dateOptions: this.dateOptionsNormalizer(result.data),
        });
      },
      (error) => {
        console.log("Error en get helper tasks");
        this.setState({ redirect: true });
      }
    );
  }

  goToTask(taskId) {
    window.location = "/" + taskId;
  }
  goToVisit(taskId) {
    window.location = "/visita/" + taskId;
  }

  createContext = (serviceDataArray) => {
    let context = [];
    for (let taskObj of serviceDataArray) {
      if (taskObj.taskStage == "VISITA") {
        context.push(
          <div
            className="task-list-row-visit"
            key={taskObj.id}
            onClick={() => {
              this.goToVisit(taskObj.id);
            }}
          >
            <Container className="container-row header-container">
              <Row>
                <Col sm={12} md={true} className="first-col">
                  {taskObj.id}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.postalcode}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.clientFirstName}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.category}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.perfilHelperStage}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.assignDate}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.visitDate}
                </Col>
              </Row>
            </Container>
          </div>
        );
      } else {
        const text_color =
          this.state.nextActionsList.getNextActionColor(taskObj);
        const date = this.state.nextActionsList.getNextActionDate(taskObj);

        context.push(
          <div
            className="task-list-row"
            key={taskObj.id}
            onClick={() => {
              this.goToTask(taskObj.id);
            }}
          >
            <Container className="container-row">
              <Row>
                <Col sm={12} md={true} className="first-col">
                  {taskObj.id}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.b2bTaskId}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.postalcode}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.clientFirstName}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.category}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.perfilHelperStage}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.assignDate}
                </Col>
                <Col sm={12} md={true} className="default-col">
                  {taskObj.visitDate}
                </Col>
                <Col
                  sm={12}
                  md={true}
                  className="default-col"
                  style={{ color: text_color }}
                >
                  {date}
                </Col>
              </Row>
            </Container>
          </div>
        );
      }
    }

    return context.reverse();
  };

  handleFilters = () => {
    const { showFilters } = this.state;
    this.setState({
      showFilters: !showFilters,
      filtersTitle: !this.state.showFilters ? "Ocultar Filtros" : "Ver Filtros",
    });
  };

  filterServiceId = (e) => {
    let currentList = [];
    let newList = [];

    if (e.target.value !== "") {
      let value = e.target.value;
      currentList = this.state.serviceData;

      newList = currentList.filter((item) => {
        return String(item.id).includes(value);
      });
    } else {
      newList = this.state.serviceData;
    }
    this.setState({
      idInputValue: e.target.value,
      filteredArray: this.paginatorNormalizer(newList),
    });
  };

  filterServiceIdB2b = (e) => {
    let currentList = [];
    let newList = [];

    if (e.target.value !== "") {
      let value = e.target.value;
      currentList = this.state.serviceData;

      newList = currentList.filter((item) => {
        return String(item.b2bTaskId).includes(value);
      });
    } else {
      newList = this.state.serviceData;
    }
    this.setState({
      idB2bInputValue: e.target.value,
      filteredArray: this.paginatorNormalizer(newList),
    });
  };

  filterStage = (selectedStageOption) => {
    let currentList = [];
    let newList = [];

    if (selectedStageOption !== "") {
      currentList = this.state.serviceData;
      newList = currentList.filter((item) => {
        return item.perfilHelperStage === selectedStageOption.label;
      });
    }

    this.setState({
      filteredArray: this.paginatorNormalizer(newList),
      selectedStageOption: selectedStageOption,
    });
  };

  filterByDate = (selectedDateOption) => {
    let currentList = [];
    let newList = [];

    if (selectedDateOption !== "") {
      currentList = this.state.serviceData;
      newList = currentList.filter((item) => {
        return item.executionDate === selectedDateOption.label;
      });
    }

    this.setState({
      filteredArray: this.paginatorNormalizer(newList),
      selectedDateOption: selectedDateOption,
    });
  };

  paginatorNormalizer = (serviceDataArr) => {
    let contextCopy = this.createContext(serviceDataArr);
    let paginatedContext = [];
    while (contextCopy.length > 0) {
      // TODO change delete count for the number of tasks per page
      let a = contextCopy.splice(0, 8);
      paginatedContext.push(a);
    }
    return paginatedContext;
  };

  stageOptionsNormalizer = (serviceDataArr) => {
    let resultArr = [];

    for (let elem of serviceDataArr) {
      resultArr.push({
        value: elem.perfilHelperStage,
        label: elem.perfilHelperStage,
      });
    }
    resultArr = this.removeArrDuplicates(resultArr, "value");

    return resultArr;
  };

  dateOptionsNormalizer = (serviceDataArr) => {
    let resultArray = [];
    for (let element of serviceDataArr) {
      resultArray.push({
        value: element.executionDate,
        label: element.executionDate,
      });
    }
    resultArray = this.removeArrDuplicates(resultArray, "value");

    return resultArray;
  };

  removeArrDuplicates = (originalArray, prop) => {
    let newArray = [];
    let lookupObject = {};

    for (let i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }
    for (let i in lookupObject) {
      newArray.push(lookupObject[i]);
    }

    return newArray;
  };

  resetFilters = () => {
    this.setState({
      idInputValue: "",
      idB2bInputValue: "",
      selectedStageOption: "",
      selectedDateOption: "",
      filteredArray: this.paginatorNormalizer(this.state.serviceData),
    });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={{ pathname: "/" }} />;
    }

    if (
      typeof this.state.serviceData === "undefined" ||
      this.state.serviceData.length === 0
    ) {
      return <LoadingSkeleton />;
    }

    const limit = 2;
    const pageCount = 3;
    const {
      currentPage,
      showFilters,
      selectedStageOption,
      selectedDateOption,
    } = this.state;
    const total = this.state.filteredArray.length * limit;

    return (
      <div>
        <span className="task-filter" onClick={this.handleFilters}>
          {this.state.filtersTitle}
        </span>
        {showFilters && (
          <div className="filter-section">
            <div className="filter-by-id">
              <label htmlFor="filterById">ID servicio:&nbsp;</label>
              <input
                type="tel"
                pattern="^-?[0-9]\d*\.?\d*$"
                id="filterById"
                value={this.state.idInputValue}
                onChange={this.filterServiceId}
              />
            </div>
            <div className="filter-by-id">
              <label htmlFor="filterByIdB2B">ID B2B:&nbsp;</label>
              <input
                type="tel"
                pattern="^-?[0-9]\d*\.?\d*$"
                id="filterByIdB2B"
                value={this.state.idB2bInputValue}
                onChange={this.filterServiceIdB2b}
              />
            </div>
            <div className="filter-by-stage">
              <label>Categoría:&nbsp;</label>
              <Select
                className="stage-select-container"
                classNamePrefix="stage-select"
                placeholder=""
                value={selectedStageOption}
                onChange={this.filterStage}
                options={this.state.stageOptions}
              />
            </div>
            <div className="filter-by-date">
              <label>Fecha del servicio:&nbsp;</label>
              <Select
                className="date-select-container"
                classNamePrefix="date-select"
                placeholder=""
                value={selectedDateOption}
                onChange={this.filterByDate}
                options={this.state.dateOptions}
              />
            </div>

            <div className="reset-filters" onClick={this.resetFilters}>
              <span>Reestablecer filtros</span>
            </div>
          </div>
        )}
        <div>
          <div className="task-list-row-header ">
            <Container className="container-row">
              <Row>
                <Col sm={12} md={true} className="header-col d-none d-md-block">
                  ID
                </Col>
                <Col sm={12} md={true} className="header-col d-none d-md-block">
                  ID B2B
                </Col>
                <Col sm={12} md={true} className="header-col d-none d-md-block">
                  Código Postal
                </Col>
                <Col sm={12} md={true} className="header-col d-none d-md-block">
                  Nombre
                </Col>
                <Col sm={12} md={true} className="header-col d-none d-md-block">
                  Categoría
                </Col>
                <Col sm={12} md={true} className="header-col d-none d-md-block">
                  Estado
                </Col>
                <Col sm={12} md={true} className="header-col d-none d-md-block">
                  F.Asignación
                </Col>
                <Col sm={12} md={true} className="header-col d-none d-md-block">
                  F.Visita
                </Col>
                <Col sm={12} md={true} className="header-col d-none d-md-block">
                  F.Acción
                </Col>
              </Row>
            </Container>
          </div>
          {this.state.filteredArray[this.state.currentPage - 1]}
        </div>

        <Pagination
          className="bg-mh"
          total={total}
          limit={limit}
          pageCount={pageCount}
          currentPage={currentPage}
        >
          {({
            pages,
            currentPage,
            hasNextPage,
            hasPreviousPage,
            previousPage,
            nextPage,
            totalPages,
            getPageItemProps,
          }) => (
            <div>
              {hasPreviousPage && (
                <button
                  className="paginating-button"
                  {...getPageItemProps({
                    pageValue: previousPage,
                    onPageChange: this.handlePageChange,
                  })}
                >
                  {"<"}
                </button>
              )}

              {pages.map((page) => {
                let activePage = null;
                if (currentPage === page) {
                  activePage = { backgroundColor: "#00cded", color: "#fff" };
                }
                if (this.state.filteredArray.length > 1) {
                  return (
                    <button
                      className="paginating-button"
                      {...getPageItemProps({
                        pageValue: page,
                        key: page,
                        style: activePage,
                        onPageChange: this.handlePageChange,
                      })}
                    >
                      {page}
                    </button>
                  );
                }
              })}

              {hasNextPage && (
                <button
                  className="paginating-button"
                  {...getPageItemProps({
                    pageValue: nextPage,
                    onPageChange: this.handlePageChange,
                  })}
                >
                  {">"}
                </button>
              )}
            </div>
          )}
        </Pagination>
      </div>
    );
  }
}

export default Tasks;
